import type { CpOrderGetOrderResponse } from 'apiConnector/secondary-market/cp-order/model';

export type SecondaryMarketCpOrderOriginalFormActions =
  | SecondaryMarketAmendCpOrderFetchRequested
  | SecondaryMarketAmendCpOrderFetched
  | SecondaryMarketAmendCpOrderFetchFailed;

export function secondaryMarketAmendCpOrderFetchRequested(tabId: string, orderId: string) {
  return {
    type: 'SECONDARY_MARKET_AMEND_CP_ORDER_FETCH_REQUESTED' as const,
    tabId,
    orderId,
  };
}

export type SecondaryMarketAmendCpOrderFetchRequested = ReturnType<typeof secondaryMarketAmendCpOrderFetchRequested>;

export function secondaryMarketAmendCpOrderFetched(tabId: string, orderId: string, data: CpOrderGetOrderResponse) {
  return {
    type: 'SECONDARY_MARKET_AMEND_CP_ORDER_FETCHED' as const,
    tabId,
    orderId,
    data,
  };
}
export type SecondaryMarketAmendCpOrderFetched = ReturnType<typeof secondaryMarketAmendCpOrderFetched>;

export function secondaryMarketAmendCpOrderFetchFailed(tabId: string, orderId: string) {
  return {
    type: 'SECONDARY_MARKET_AMEND_CP_ORDER_FETCH_FAILED' as const,
    tabId,
    orderId,
  };
}
export type SecondaryMarketAmendCpOrderFetchFailed = ReturnType<typeof secondaryMarketAmendCpOrderFetchFailed>;
